export interface ImageDTOApi {
  get imageId(): string;
  get imageData(): File | string | undefined;
  get imageSrc(): string;
}

export default class ImageDTO implements ImageDTOApi {
  private _imageData: { id: string; data?: File | string; src: string };

  constructor(imageData: { id: string; data?: File | string; src: string }) {
    this._imageData = imageData;
  }

  get imageId(): string {
    return this._imageData.id;
  }

  get imageData(): File | string | undefined {
    return this._imageData.data;
  }

  get imageSrc(): string {
    return this._imageData.src;
  }
}
